import { Button } from '../../../../../../components/button/button';
import { Modal, ModalProps } from '../../../../../../components/modal/modal';
import { LangType } from '../../../../../../helpers/lang';
import { useLang } from '../../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../../hooks/use-query-params';
import { FormElementTypeType } from '../../../../../../store/api/forms-api';
import s from './tasks-form-modal.module.css';
import { DateTimeRange } from '../../../../../../features/date-time/datetime-range/datetime-range';
import { IdValue } from '../../../../../../types/props';
import { Container } from '../../../../../../components/container/container';
import { Chip } from '../../../../../../components/chip/chip';
import { Checkbox } from '../../../../../../components/checkbox/checkbox';
import { Switch } from '../../../../../../components/switch/switch';
import { DateTime } from '../../../../../../features/date-time/date-time';

export const TasksFormModal = (props: ModalProps) => {
  const params = useQueryParams().getQueryParams();
  const form = params.form;
  const { t, getLocale } = useLang();

  const parsedForm = form ? (JSON.parse(form) as Record<string, unknown>) : null;
  return (
    <Modal
      {...props}
      title={parsedForm?.title ? getLocale(parsedForm.title) : t('Форма')}
      className={s.feature}
    >
      {parsedForm ? (
        Object.values(parsedForm)
          .sort((a, b) => (a as { order: number }).order - (b as { order: number }).order)
          .map((item, index) => {
            const type = (item as { type: FormElementTypeType }).type;

            if (type === 'datetimeRange') {
              const content = item as { from: string; to: string; helperText: LangType };

              return (
                <Container key={index} label={getLocale(content.helperText)}>
                  <DateTimeRange
                    fromValue={content.from}
                    toValue={content.to}
                    onChangeFrom={() => {}}
                    onChangeTo={() => {}}
                    disabled
                  />
                </Container>
              );
            }

            if (type === 'multi-select') {
              const content = item as {
                helperText: LangType;
                value: IdValue[];
                counter?: Record<string, number>;
              };

              if (!content.value.length) return null;

              return (
                <Container label={getLocale(content.helperText)} key={index}>
                  <ul key={index} className={s.multiSelect}>
                    {content.value.map((item) => (
                      <Chip key={item.id} variant="info">
                        {item.value} {content.counter ? `(${content.counter[item.id]})` : ''}
                      </Chip>
                    ))}
                  </ul>
                </Container>
              );
            }

            if (type === 'select') {
              const content = item as { helperText: LangType; value: IdValue };
              if (!content.value) return null;

              return (
                <Container label={getLocale(content.helperText)} key={index}>
                  <Chip variant="info">{content.value.value}</Chip>
                </Container>
              );
            }

            if (type === 'input') {
              const content = item as { helperText: LangType; value: string };
              if (!content.value) return null;

              return (
                <Container label={getLocale(content.helperText)} key={index}>
                  <span>{content.value}</span>
                </Container>
              );
            }

            if (type === 'checkbox') {
              const content = item as { helperText: LangType; value: boolean };

              return (
                <Checkbox
                  label={getLocale(content.helperText)}
                  key={index}
                  checked={content.value}
                />
              );
            }

            if (type === 'switch') {
              const content = item as { helperText: LangType; value: boolean };

              return (
                <Switch
                  label={getLocale(content.helperText)}
                  isOn={content.value}
                  offLabel={getLocale(content.helperText)}
                  onLabel={getLocale(content.helperText)}
                  key={index}
                  onToggle={() => {}}
                />
              );
            }

            if (type === 'datetime') {
              const content = item as { helperText: LangType; value: string };

              if (!content.value) return null;
              return (
                <Container label={getLocale(content.helperText)} key={index}>
                  <DateTime disabled onChange={() => {}} value={content.value} />
                </Container>
              );
            }
            return null;
          })
      ) : (
        <span>{t('Форма не найдена')}</span>
      )}
      <div className={s.controls}>
        <Button variant="secondary" onClick={props.onClose}>
          {t('Назад')}
        </Button>
      </div>
    </Modal>
  );
};
